import type { ReactNode } from 'react';
import clsx from 'clsx';
import styles from './MediaThumbnailContentBottom.module.css';

type MediaThumbnailContentBottomProps = {
  variant?: 'list-item' | 'item-detail';
  contentTopLeft?: ReactNode;
  contentTopRight?: ReactNode;
  contentBottom?: ReactNode;
};

/**
 * The MediaThumbnail component in Vapor support either bottom-content or
 * bottom-left-content/bottom-right-content.
 * This component can be passed into bottom-content to support layouts where
 * bottom-content and bottom-left/bottom-right content are present.
 */
export const MediaThumbnailContentBottom = ({
  contentTopLeft,
  contentTopRight,
  contentBottom,
  variant = 'list-item',
}: MediaThumbnailContentBottomProps) => {
  const hasTopLeftContent = Boolean(contentTopLeft);
  const hasTopRightContent = Boolean(contentTopRight);
  const hasBottomContent = Boolean(contentBottom);

  if (!hasTopLeftContent && !hasTopRightContent && !hasBottomContent) {
    return null;
  }

  return (
    <div
      className={clsx(styles.container, {
        [styles.containerListItem]: variant === 'list-item',
        [styles.containerItemDetail]: variant === 'item-detail',
      })}
    >
      <div
        className={clsx(styles.row, {
          [styles.rowSpaceBetween]: hasTopLeftContent && hasTopRightContent,
          [styles.rowFlexEnd]: !hasTopLeftContent && hasTopRightContent,
        })}
      >
        {hasTopLeftContent && contentTopLeft}
        {hasTopRightContent && contentTopRight}
      </div>
      {hasBottomContent && (
        <div
          className={clsx({
            [styles.bottomContentListItem]: variant === 'list-item',
            [styles.bottomContentItemDetail]: variant === 'item-detail',
          })}
        >
          {contentBottom}
        </div>
      )}
    </div>
  );
};
